import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import Axis from '../Axis';

var YAxis = function YAxis(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'linear' : _ref$type,
      restProps = _objectWithoutProperties(_ref, ["type"]);

  return /*#__PURE__*/React.createElement(Axis, _extends({
    type: type
  }, restProps, {
    isX: false
  }));
};

YAxis.displayName = 'YAxis';
YAxis.Title = Axis.Title;
export default YAxis;